import {Product} from './Product';
import {VatRateService} from '../../services/vat-rate.service';
import {ContractItemTransfer} from './ContractItemTransfer';
import {ContractItemType} from './ContractItemType';
import {ContractItem} from './ContractItem';

export class DeliveryContractItem extends ContractItem {

    name = 'Doprava';
    order = 9999;
    hirePrice = 0;
    vat = VatRateService.VAT21;
    type: ContractItemType = ContractItemType.delivery;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/DeliveryContractItem.ts